import { DetailsComponent } from './../details/details.component';
import { Injectable } from '@angular/core';
import { Headers, Http, RequestOptions, URLSearchParams } from '@angular/http';
import { DialogService } from 'ng2-bootstrap-modal';

import { environment } from '../../environments/environment';
import { APIURLS, SHAREDCONSTANTS } from '../_constants/constants';
import { RemememberMeResult } from './../_models/data.structures';
import { NotificationDialogComponent } from './../notification/notification.dialog.component';

import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';

import { LoaderService } from '../_services/loader.service';

@Injectable()
export class RememberMeService {
    private remembermeresult: RemememberMeResult;

    constructor(private http: Http, private ds: DialogService, private loaderService: LoaderService) {
    }


    getRememberMeListData(page: number, subValue: string, opcoValue: string, itemsPerPage:number, offset:number): Observable<any> {        

        const params = new URLSearchParams();
        const URL = (environment.BASE_URL_BACKEND + APIURLS.APPS_Remember_Me_All_Grant).replace('{sub}', subValue);
        
        params.append("offset", String(offset));
        params.append("count", String(itemsPerPage));

        const headers = new Headers();

        headers.append('Accept', 'application/json');
        headers.append('x-int-opco-id', opcoValue);
        headers.append('If-Modified-Since', 'Mon, 26 Jul 1997 05:00:00 GMT');
        headers.append('Cache-Control', 'no-cache');
        headers.append('Pragma', 'no-cache');

        const options = new RequestOptions({ headers: headers, withCredentials: true, search: params });


         return this.http.get(URL, options).map(response => response.json());             
    }

    getAllRememberMeList(subValue: string, opcoValue: string){
        DetailsComponent.incrementRunningRequests();
        this.loaderService.display(true);
        const URL = (environment.BASE_URL_BACKEND + APIURLS.APPS_Remember_Me_All_Grant).replace('{sub}', subValue);
        console.log(URL);
        const headers = new Headers();

        headers.append('Accept', 'application/json');
        headers.append('x-int-opco-id', opcoValue);
        headers.append('If-Modified-Since', 'Mon, 26 Jul 1997 05:00:00 GMT');
        headers.append('Cache-Control', 'no-cache');
        headers.append('Pragma', 'no-cache');
        const options = new RequestOptions({ headers: headers, withCredentials: true });

        this.http.get(URL, options).subscribe(
            res => {
                DetailsComponent.decrementRunningRequests();
                this.loaderService.display(false);
                this.remembermeresult = res.json();
                console.log("Result:");
                console.log(res.json());
            },
            err => {
                this.remembermeresult = '';
                DetailsComponent.decrementRunningRequests();
                this.loaderService.display(false);
                if(err.json().code == "IDP_ERROR"){
                    this.ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: err.json().message
                    });
                }else{
                    this.ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: SHAREDCONSTANTS.COMMON_ERROR_MESSAGE
                    });
                }
            });
    }

    getAllRememberMeResult(): RemememberMeResult{
        return this.remembermeresult;
    }


    deleteRememberMeSingle(seriesIdentifier, subValue, opcoValue){
        
        const URL = (environment.BASE_URL_BACKEND + APIURLS.APPS_Remember_Me_Remove_Grant).replace('{sub}', subValue).replace('{seriesIdentifier}', seriesIdentifier);
        
        const headers = new Headers();
        headers.append('Accept', 'application/json');
        headers.append('x-int-opco-id', opcoValue);
        headers.append('If-Modified-Since', 'Mon, 26 Jul 1997 05:00:00 GMT');
        headers.append('Cache-Control', 'no-cache');
        headers.append('Pragma', 'no-cache');
        const options = new RequestOptions({ headers: headers, withCredentials: true });


        return this.http.delete(URL, options).map(response => response); 

    }

    DeleteRememberMe(seriesIdentifier, subValue, opcoValue){
        console.log(seriesIdentifier);
        console.log("Delete called");
        DetailsComponent.incrementRunningRequests();
        this.loaderService.display(true);
        const URL = (environment.BASE_URL_BACKEND + APIURLS.APPS_Remember_Me_Remove_Grant).replace('{sub}', subValue).replace('{seriesIdentifier}', seriesIdentifier);
        
        const headers = new Headers();
        headers.append('Accept', 'application/json');
        headers.append('x-int-opco-id', opcoValue);
        headers.append('If-Modified-Since', 'Mon, 26 Jul 1997 05:00:00 GMT');
        headers.append('Cache-Control', 'no-cache');
        headers.append('Pragma', 'no-cache');
        const options = new RequestOptions({ headers: headers, withCredentials: true });

        this.http.delete(URL, options).subscribe(
            res => {
                this.getAllRememberMeList(subValue, opcoValue)
                DetailsComponent.decrementRunningRequests();
                this.loaderService.display(false);
                this.ds.addDialog(NotificationDialogComponent,
                    {
                        success: true,
                        message: 'Success!'
                    });
            },
            err => {
                DetailsComponent.decrementRunningRequests();
                this.loaderService.display(false);
                if(err.json().code == "IDP_ERROR"){
                    this.ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: err.json().message
                    });
                }else{
                    this.ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: SHAREDCONSTANTS.COMMON_ERROR_MESSAGE
                    });
                }
            });
    }



    deleteRememberMeAll(subValue: string, opcoValue: string){


        const URL = (environment.BASE_URL_BACKEND + APIURLS.APPS_Remember_Me_Remove_All_Grant).replace('{sub}', subValue);
        
        const headers = new Headers();
        headers.append('Accept', 'application/json');
        headers.append('x-int-opco-id', opcoValue);
        headers.append('If-Modified-Since', 'Mon, 26 Jul 1997 05:00:00 GMT');
        headers.append('Cache-Control', 'no-cache');
        headers.append('Pragma', 'no-cache');
        const options = new RequestOptions({ headers: headers, withCredentials: true });


        return this.http.delete(URL, options).map(response => response.json); 

    }

    DeleteAllRememberMe(subValue: string, opcoValue: string){
        
        console.log("Delete All called");
        DetailsComponent.incrementRunningRequests();
        this.loaderService.display(true);
        const URL = (environment.BASE_URL_BACKEND + APIURLS.APPS_Remember_Me_Remove_All_Grant).replace('{sub}', subValue);
        
        console.log(URL);
        const headers = new Headers();
        headers.append('Accept', 'application/json');
        headers.append('x-int-opco-id', opcoValue);
        headers.append('If-Modified-Since', 'Mon, 26 Jul 1997 05:00:00 GMT');
        headers.append('Cache-Control', 'no-cache');
        headers.append('Pragma', 'no-cache');
        const options = new RequestOptions({ headers: headers, withCredentials: true });

        this.http.delete(URL, options).subscribe(
            res => {
                this.remembermeresult = '';
                DetailsComponent.decrementRunningRequests();
                this.loaderService.display(false);
                this.ds.addDialog(NotificationDialogComponent,
                    {
                        success: true,
                        message: 'Success!'
                    });
            },
            err => {
                DetailsComponent.decrementRunningRequests();
                this.loaderService.display(false);
                if(err.json().code == "IDP_ERROR"){
                    this.ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: err.json().message
                    });
                }else{
                    this.ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: SHAREDCONSTANTS.COMMON_ERROR_MESSAGE
                    });
                }
            });
    }

    GetRememberMeDetailsLink(url: string, subValue: string, opcoValue: string){

        const URL = url.replace('{sub}', subValue);
        console.log("Link URL" + URL);

        const headers = new Headers();
        headers.append('Accept', 'application/json');
        headers.append('x-int-opco-id', opcoValue);
        headers.append('If-Modified-Since', 'Mon, 26 Jul 1997 05:00:00 GMT');
        headers.append('Cache-Control', 'no-cache');
        headers.append('Pragma', 'no-cache');
        const options = new RequestOptions({ headers: headers, withCredentials: true });

        this.http.get(URL, options).subscribe(
            res => {
                DetailsComponent.decrementRunningRequests();
                this.loaderService.display(false);
                this.remembermeresult = res.json();
                console.log("Result:");
                console.log(res.json());
            },
            err => {
                DetailsComponent.decrementRunningRequests();
                this.loaderService.display(false);
                if(err.json().code == "IDP_ERROR"){
                    this.ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: err.json().message
                    });
                }else{
                    this.ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: SHAREDCONSTANTS.COMMON_ERROR_MESSAGE
                    });
                }
            });

    }
}


// WEBPACK FOOTER //
// ./src/app/_services/rememberme.service.ts